<template>
  <t-block-allow-domain
    v-if="selectedMsp.id"
    :id="selectedMsp.id"
    :tier="TIER.msps"
  ></t-block-allow-domain>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import TBlockAllowDomain from "@/views/Common/TBlockAllowDomain";

import { TIER } from "@/constants/tier";

export default {
  name: "Domains",
  components: {
    TBlockAllowDomain,
  },
  data() {
    return {
      TIER,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("modal", ["openModal", "closeModal"]),
  },
  mounted() {
    this.setPageTitle(this.$t("Allow & Block List"));
    this.setPageSubtitle([]);
  },
};
</script>
